// extracted by mini-css-extract-plugin
module.exports = {"root":"ActionMenuPopper_root__9r6p5","paper":"ActionMenuPopper_paper__GpQbP","content":"ActionMenuPopper_content__G9Kqj","closeBtn":"ActionMenuPopper_closeBtn__bv0Qu"};